module.exports = __webpack_public_path__ + "static/media/pathetic_2.bdb131b0.wav";